export const superAdmin = {
    appName: "Sobthik সুপার অ্যাডমিন",
    badge: "সুপার অ্যাডমিন",
    signIn: {
        title: "সুপার অ্যাডমিন সাইন-ইন",
        description: "শুধু প্ল্যাটফর্ম অ্যাডমিনদের জন্য। আপনার পাসওয়ার্ড, আর টু-স্টেপ সাইন-ইন চালু থাকলে অথেনটিকেটর কোড।",
        identifier: "ইমেইল বা ফোন",
        password: "পাসওয়ার্ড",
        code: "অথেনটিকেটর কোড",
        codeHint: "শুধু আপনার অ্যাকাউন্টে টু-স্টেপ সাইন-ইন চালু থাকলে।",
        submit: "সাইন ইন",
    },
    nav: {
        overview: "সারসংক্ষেপ",
        tenants: "ব্যবসাসমূহ",
        payments: "পেমেন্ট",
        operations: "অপারেশনস",
        announcements: "ঘোষণা",
        plans: "প্ল্যান",
        closures: "বন্ধের অনুরোধ",
        feedback: "ফিডব্যাক",
        leads: "বিক্রয় অনুসন্ধান",
        domains: "দোকানের ডোমেইন",
        storefronts: "অনলাইন স্টোর",
        settings: "সেটিংস",
        themeDemos: "থিমের ডেমো দোকান",
    },
    setup: {
        title: "প্রথম সুপার অ্যাডমিন তৈরি করুন",
        description: "এখনো কোনো সুপার অ্যাডমিন নেই। এখানে তৈরি অ্যাকাউন্টই প্ল্যাটফর্মের মালিক হবে।",
        name: "আপনার নাম",
        email: "ইমেইল",
        phone: "মোবাইল নম্বর (ঐচ্ছিক)",
        password: "পাসওয়ার্ড",
        passwordHint: "কমপক্ষে ৮ অক্ষর।",
        submit: "তৈরি করে সাইন ইন করুন",
    },
    settings: {
        title: "সেটিংস",
        description: "প্ল্যাটফর্ম সেটিংস সাথে সাথে কার্যকর হয়, ডিপ্লয় লাগে না।",
        ownerOnly: "শুধু প্ল্যাটফর্ম মালিক এই সেটিংস বদলাতে পারেন।",
        signupTitle: "মার্চেন্ট সাইন-আপ",
        signupBody: "নতুন মার্চেন্ট সাইন-আপ কোড কোথায় পাবেন।",
        bySms: "SMS-এ কোড (মোবাইল নম্বর যাচাই হয়)",
        byEmail: "ই-মেইলে কোড (মোবাইল নম্বর এখন যাচাই হয় না)",
        noSms: "কোনো SMS গেটওয়ে যুক্ত নেই: SMS কোড বাছলে কেউ সাইন-আপ করতে পারবে না।",
        totpTitle: "সুপার অ্যাডমিন সাইন-ইন",
        totpRequired: "সব সুপার অ্যাডমিনের জন্য টু-স্টেপ সাইন-ইন বাধ্যতামূলক",
        totpHint: "বন্ধ থাকলে পাসওয়ার্ডই যথেষ্ট, যদি না কোনো অ্যাডমিন নিজে টু-স্টেপ সাইন-ইন চালু করে থাকেন।",
        saved: "সেটিংস সংরক্ষিত",
    },
    billingSettings: {
        title: "বিলিং সেটিংস",
        description: "ইনভয়েসে কার নাম থাকবে, ব্যবসাগুলো কোথায় টাকা পাঠাবে, VAT আর পেমেন্টের সময়সীমা।",
        seller: "ইনভয়েসের বিক্রেতা",
        sellerName: "বিক্রেতার নাম",
        sellerAddress: "বিক্রেতার ঠিকানা",
        sellerBin: "BIN",
        binHint: "১৩ অঙ্ক, অথবা খালি।",
        vat: "VAT (%)",
        notifyEmail: "নতুন পেমেন্ট রিকোয়েস্টের ই-মেইল",
        bkash: "প্ল্যান পেমেন্টের বিকাশ",
        bkashNumber: "বিকাশ নম্বর",
        bkashType: "অ্যাকাউন্টের ধরন",
        types: { personal: "পার্সোনাল", agent: "এজেন্ট", merchant: "মার্চেন্ট" },
        timeline: "পেমেন্টের সময়সীমা (দিন)",
        invoiceDueDays: "ইনভয়েসের মেয়াদ",
        reminderDays: "মেয়াদের আগে রিমাইন্ডার",
        reminderHint: "দিনগুলো কমা দিয়ে: 7, 3, 1",
        graceDays: "গ্রেস পিরিয়ড",
        restrictedDays: "সীমিত থাকবে",
        retentionDays: "স্থগিতের পরে ডাটা রাখা",
        warnBeforeDays: "সীমিত করার আগে সতর্কতা",
        invalid: "VAT আর দিনের ঘরগুলোতে সংখ্যা দিন।",
        confirmTitle: "বিলিং সেটিংস সেভ করুন",
        confirmBody: "নতুন ইনভয়েস আর পেমেন্ট পেজে এগুলো সাথে সাথে কাজ করবে। আগে দেওয়া ইনভয়েস বদলাবে না।",
        saved: "বিলিং সেটিংস সেভ হয়েছে",
    },
    security: {
        title: "আমার টু-স্টেপ সাইন-ইন",
        on: "আপনার অ্যাকাউন্টে টু-স্টেপ সাইন-ইন চালু আছে।",
        off: "আপনার অ্যাকাউন্টে টু-স্টেপ সাইন-ইন বন্ধ আছে।",
        turnOn: "চালু করুন",
        turnOff: "বন্ধ করুন",
        requiredLocked: "সব সুপার অ্যাডমিনের জন্য বাধ্যতামূলক, তাই বন্ধ করা যাবে না।",
        enrolTitle: "চালিয়ে যেতে টু-স্টেপ সাইন-ইন চালু করুন",
        enrolBody: "এই প্ল্যাটফর্মে সব সুপার অ্যাডমিনের টু-স্টেপ সাইন-ইন বাধ্যতামূলক।",
        manual: "আপনার অথেনটিকেটর অ্যাপে (Google Authenticator, Authy, …) একটি অ্যাকাউন্ট যোগ করে এই সেটআপ কী লিখুন:",
    },
    newBusiness: {
        open: "নতুন ব্যবসা",
        title: "ব্যবসা তৈরি করুন",
        description: "মালিক অস্থায়ী পাসওয়ার্ড দিয়ে সাইন ইন করবেন, তারপর নিজের পাসওয়ার্ড দিয়ে শর্তাবলি মেনে নেবেন।",
        businessName: "ব্যবসার নাম",
        businessType: "কীভাবে বিক্রি করেন",
        plannedBranches: "শাখা",
        ownerName: "মালিকের নাম",
        email: "মালিকের ইমেইল",
        phone: "মালিকের মোবাইল নম্বর",
        temporaryPassword: "অস্থায়ী পাসওয়ার্ড (খালি রাখলে আমরা বানাব)",
        submit: "ব্যবসা তৈরি করুন",
        createdTitle: "ব্যবসা তৈরি হয়েছে",
        createdBody: "এই অস্থায়ী পাসওয়ার্ডটি মালিককে দিন। এটি শুধু এখনই দেখানো হচ্ছে; প্রথম সাইন-ইনে বদলাতে হবে।",
        copy: "কপি",
        copied: "কপি হয়েছে",
        openBusiness: "ব্যবসাটি খুলুন",
    },
    reason: {
        label: "কারণ",
        hint: "প্ল্যাটফর্ম অডিট লগে রাখা হবে।",
    },
    status: {
        trial: "ট্রায়াল",
        active: "সক্রিয়",
        restricted: "সীমিত",
        suspended: "স্থগিত",
        closed: "বন্ধ",
    },
    overview: {
        title: "সারসংক্ষেপ",
        description: "সংখ্যায় প্ল্যাটফর্ম।",
        mrr: "মাসিক পুনরাবৃত্ত আয়",
        active: "সক্রিয় ব্যবসা",
        trial: "ট্রায়ালে",
        atRisk: "সীমিত বা স্থগিত",
        conversion: "ট্রায়াল থেকে পেইড",
        months: "গত ১২ মাস",
        month: "মাস",
        signups: "সাইনআপ",
        firstPayments: "প্রথম পেমেন্ট",
        churned: "চলে গেছে",
    },
    tenants: {
        title: "ব্যবসাসমূহ",
        description: "প্ল্যাটফর্মের সব ব্যবসা।",
        search: "নাম বা স্লাগ দিয়ে খুঁজুন",
        allStatuses: "সব অবস্থা",
        name: "ব্যবসা",
        plan: "প্ল্যান",
        status: "অবস্থা",
        mrr: "MRR",
        created: "সাইনআপ",
        lastActivity: "সর্বশেষ কার্যক্রম",
        never: "কখনো না",
        empty: "কোনো ব্যবসা মেলেনি।",
    },
    tenant: {
        facts: "অ্যাকাউন্ট",
        trialEnds: "ট্রায়াল শেষ",
        dueAt: "পেমেন্টের শেষ তারিখ",
        stage: "পেমেন্টের ধাপ",
        usage: "ব্যবহার",
        limit: "{{limit}}-এর মধ্যে {{usage}}",
        unlimited: "{{usage}} (সীমা নেই)",
        flags: "ফিচার ফ্ল্যাগ",
        noFlags: "এখনো কোনো ফিচার ফ্ল্যাগ নেই।",
        overrides: "ওভাররাইড",
        noOverrides: "কোনো ওভাররাইড নেই।",
        notes: "অভ্যন্তরীণ নোট",
        noNotes: "এখনো কোনো নোট নেই।",
        support: "সাপোর্ট অ্যাক্সেস",
        noSupport: "মালিক সাপোর্ট অ্যাক্সেস দেননি।",
        supportUntil: "{{date}} পর্যন্ত অনুমতি",
        invoices: "ইনভয়েস",
        noInvoices: "এখনো কোনো ইনভয়েস নেই।",
        on: "চালু",
        off: "বন্ধ",
        actions: {
            plan: "প্ল্যান বদলান",
            extendTrial: "ট্রায়াল বাড়ান",
            suspend: "স্থগিত করুন",
            reactivate: "আবার চালু করুন",
            note: "নোট যোগ করুন",
            override: "ওভাররাইড দিন",
            flagOn: "চালু করুন",
            flagOff: "বন্ধ করুন",
            openSupport: "সাপোর্ট হিসেবে খুলুন",
        },
        dialogs: {
            plan: "এই ব্যবসাকে অন্য প্ল্যানে নিন",
            extendTrial: "এই ব্যবসাকে আরও কিছু ট্রায়ালের দিন দিন",
            days: "দিন",
            suspend: "এই ব্যবসা স্থগিত করুন",
            suspendBody: "আবার চালু না করা পর্যন্ত স্টাফরা শুধু বিলিং দেখতে পারবে। POS বিক্রি চালু থাকবে।",
            reactivate: "স্থগিত বা সীমাবদ্ধতা তুলে নিন",
            note: "প্ল্যাটফর্ম টিমের জন্য নোট (ব্যবসা কখনো দেখবে না)",
            noteBody: "নোট",
            override: "এই ব্যবসার জন্য প্ল্যানের একটি মান বদলান",
            key: "মান",
            value: "নতুন মান (খালি = সীমাহীন)",
            flag: "ফিচার ফ্ল্যাগ বদলান",
            openSupport: "সাপোর্ট হিসেবে এই ব্যবসা খুলুন",
            supportOpened: "{{date}} পর্যন্ত সাপোর্ট সেশন খোলা। টোকেনটি অ্যাডমিনের সাপোর্ট সাইন-ইনে (/support-sign-in) দিন।",
            copyToken: "টোকেন কপি করুন",
            copied: "কপি হয়েছে",
        },
        done: "সংরক্ষিত",
    },
    payments: {
        title: "পেমেন্ট",
        description: "অনুমোদনের অপেক্ষায় থাকা পেমেন্ট, পুরনোটা আগে। অনুমোদনের আগে বিকাশ স্টেটমেন্ট বা নগদ দেখে নিন।",
        empty: "কোনো পেমেন্ট অপেক্ষায় নেই।",
        business: "ব্যবসা",
        invoice: "ইনভয়েস",
        amount: "পরিমাণ",
        how: "কীভাবে",
        waiting: "অপেক্ষা",
        hours: "{{hours}} ঘণ্টা",
        late: "দেরি",
        cash: "নগদ",
        bkash: "বিকাশ {{trxId}}, পাঠিয়েছে {{phone}}",
        approve: "অনুমোদন",
        reject: "বাতিল",
        approveTitle: "টাকা এসেছে: প্ল্যান চালু করুন",
        note: "নোট (ঐচ্ছিক)",
        rejectTitle: "টাকা আসেনি বা ঠিক নয়: ব্যবসাকে কারণ জানান",
        approved: "অনুমোদিত: প্ল্যান চালু হয়েছে।",
        rejected: "বাতিল: ব্যবসাকে জানানো হয়েছে।",
    },
    operations: {
        title: "অপারেশনস",
        description: "কিউ, ব্যর্থ কাজ, POS রিভিউ ও সিস্টেমের অবস্থা।",
        health: "সিস্টেমের অবস্থা",
        database: "ডাটাবেস",
        redis: "Valkey",
        backups: "ব্যাকআপ",
        up: "চালু",
        down: "বন্ধ",
        notConfigured: "সেট করা হয়নি",
        queues: "কিউ",
        queue: "কিউ",
        waiting: "অপেক্ষায়",
        active: "চলছে",
        delayed: "বিলম্বিত",
        failed: "ব্যর্থ",
        failedJobs: "ব্যর্থ কাজ",
        noFailed: "কোনো ব্যর্থ কাজ নেই।",
        job: "কাজ",
        error: "ত্রুটি",
        attempts: "চেষ্টা",
        when: "কখন",
        retry: "আবার চালান",
        retryTitle: "এই কাজটি আবার চালান",
        retried: "কাজটি আবার কিউতে দেওয়া হয়েছে।",
        reviews: "খোলা POS সিঙ্ক রিভিউ",
        noReviews: "কোনো খোলা রিভিউ নেই।",
        open: "খোলা",
    },
    announcements: {
        title: "ঘোষণা",
        description: "অ্যাডমিনের উপরে দেখানো বার্তা।",
        create: "নতুন ঘোষণা",
        titleEn: "শিরোনাম (ইংরেজি)",
        titleBn: "শিরোনাম (বাংলা)",
        bodyEn: "লেখা (ইংরেজি)",
        bodyBn: "লেখা (বাংলা)",
        level: "ধরন",
        info: "তথ্য",
        warning: "সতর্কতা",
        audience: "কারা দেখবে",
        everyone: "সব ব্যবসা",
        chosen: "বাছাই করা ব্যবসা",
        tenantIds: "ব্যবসার আইডি (প্রতি লাইনে একটি)",
        endsAt: "শেষ (ঐচ্ছিক)",
        publish: "প্রকাশ করুন",
        end: "এখনই শেষ করুন",
        ended: "শেষ",
        showing: "দেখানো হচ্ছে",
        scheduled: "নির্ধারিত",
        empty: "এখনো কোনো ঘোষণা নেই।",
        published: "প্রকাশিত।",
    },
    plans: {
        title: "প্ল্যান",
        description: "প্ল্যান, এর ফিচার ও দাম। এখান থেকে deploy ছাড়াই সব বদলানো যায়; প্রতিটি পরিবর্তনে কারণ লাগে।",
        monthly: "মাসিক",
        yearly: "বার্ষিক",
        noPrice: "দাম নেই",
        changePrice: "দাম বদলান",
        priceTitle: "{{plan}} প্ল্যানের দাম বদলান",
        cycle: "মেয়াদ",
        price: "দাম",
        retired: "বন্ধ",
        default: "ডিফল্ট",
        hidden: "প্রকাশ্য নয়",
        unlimited: "সীমাহীন",
        saved: "দাম সংরক্ষিত।",
        tabs: { plans: "প্ল্যান", grid: "তুলনা ও এডিট", features: "ফিচার তালিকা", addons: "অ্যাড-অন" },
        perMonth: "/ মাস",
        perYear: "/ বছর",
        businesses_one: "{{count}}টি ব্যবসা",
        businesses_other: "{{count}}টি ব্যবসা",
        highlighted: "সুপারিশকৃত",
        newPlan: "নতুন প্ল্যান",
        duplicate: "কপি করুন",
        editDetails: "বিবরণ এডিট",
        newTitle: "নতুন প্ল্যান",
        duplicateTitle: "{{plan}} কপি করুন",
        newHint: "নতুন প্ল্যান প্রথমে প্রাইসিং পেজে লুকানো থাকে। মান ও দাম ঠিক করে তারপর প্রকাশ্য করুন।",
        key: "কী",
        keyHint: "ছোট হাতের অক্ষর, সংখ্যা ও _; এটি কখনো বদলায় না।",
        nameEn: "নাম (ইংরেজি)",
        nameBn: "নাম (বাংলা)",
        created: "প্ল্যান তৈরি হয়েছে। প্রকাশ্য না করা পর্যন্ত লুকানো থাকবে।",
        detailsTitle: "{{plan}} এডিট করুন",
        taglineEn: "ট্যাগলাইন (ইংরেজি)",
        taglineBn: "ট্যাগলাইন (বাংলা)",
        badgeEn: "ব্যাজ (ইংরেজি)",
        badgeBn: "ব্যাজ (বাংলা)",
        badgeHint: "খালি রেখে “সুপারিশকৃত” চালু করলে “সবচেয়ে জনপ্রিয়” দেখাবে।",
        sortOrder: "ক্রম",
        trialDays: "ট্রায়ালের দিন (ডিফল্ট প্ল্যান)",
        isPublic: "প্রাইসিং পেজ ও বিলিংয়ে দেখান",
        isHighlighted: "সুপারিশকৃত (হাইলাইট করে দেখাবে)",
        makeDefault: "নতুন ব্যবসার (ট্রায়াল) ডিফল্ট প্ল্যান",
        status: "স্ট্যাটাস",
        statusActive: "চালু",
        statusRetired: "বন্ধ (নতুন ব্যবসা নেবে না)",
        detailsSaved: "প্ল্যান সংরক্ষিত।",
        feature: "ফিচার",
        notChecked: "এখনো চেক হয় না",
        notCheckedHint: "প্ল্যানে দেখায়, কিন্তু অ্যাপ এখনো এটি আটকায় না।",
        display: "শুধু দেখানোর জন্য",
        on: "আছে",
        off: "নেই",
        note: "নোট",
        noteTitle: "{{plan}} প্ল্যানে {{feature}}-এর নোট",
        noteEn: "নোট (ইংরেজি)",
        noteBn: "নোট (বাংলা)",
        noteHint: "মানের পাশে দেখাবে, যেমন “৩টি ব্রাঞ্চ পর্যন্ত”।",
        changed_one: "{{count}}টি পরিবর্তন",
        changed_other: "{{count}}টি পরিবর্তন",
        discard: "বাতিল",
        saveChanges: "পরিবর্তন সংরক্ষণ",
        saveTitle: "{{plan}} প্ল্যানের পরিবর্তন সংরক্ষণ",
        saveNext: "সংরক্ষণ করে পরের প্ল্যানে যান",
        impactLoading: "কারা প্রভাবিত হবে দেখা হচ্ছে…",
        impactBusinesses_one: "এই প্ল্যানে {{count}}টি ব্যবসা আছে।",
        impactBusinesses_other: "এই প্ল্যানে {{count}}টি ব্যবসা আছে।",
        impactTrials_one: "{{count}}টি ট্রায়াল এটিকে ডিফল্ট প্ল্যান হিসেবে ব্যবহার করে।",
        impactTrials_other: "{{count}}টি ট্রায়াল এটিকে ডিফল্ট প্ল্যান হিসেবে ব্যবহার করে।",
        smaller: "কমছে",
        overLimit: "{{businesses}}টি ব্যবসা ও {{trials}}টি ট্রায়াল এখনই এর বেশি ব্যবহার করছে। কিছু মুছবে না; শুধু নতুন যোগ করতে পারবে না।",
        mode: "এই প্ল্যানে থাকা ব্যবসাগুলো",
        keepExisting: "তাদের বর্তমান শর্ত রাখুন (সুপারিশকৃত)",
        keepExistingHint: "প্ল্যান না বদলানো পর্যন্ত যা কমছে তার পুরনো মান তারা পাবে। ট্রায়ালরা নতুন মান পাবে।",
        applyToAll: "এখনই সবার জন্য প্রযোজ্য",
        applyToAllHint: "এই প্ল্যানের সব ব্যবসা সাথে সাথে নতুন মান পাবে।",
        valuesSaved: "প্ল্যানের মান সংরক্ষিত।",
        groups: {
            usage: "লিমিট ও ক্রেডিট",
            channels: "বিক্রির চ্যানেল",
            stock: "স্টক ও অপারেশন",
            delivery: "ডেলিভারি",
            payments: "পেমেন্ট",
            customers: "কাস্টমার",
            accounts_reports: "হিসাব ও রিপোর্ট",
            team: "টিম",
            integrations: "ইন্টিগ্রেশন",
            support: "সাপোর্ট",
        },
        kinds: { limit: "লিমিট", credit: "ক্রেডিট", feature: "ফিচার", display: "শুধু দেখানো" },
        addLine: "লাইন যোগ করুন",
        addLineTitle: "প্ল্যানে একটি লাইন যোগ করুন",
        addLineHint: "শুধু প্ল্যানে দেখানোর লাইন, যেমন “হোয়াটসঅ্যাপ সাপোর্ট”। অ্যাপ এটি কখনো চেক করে না।",
        lineKey: "কী",
        lineKeyHint: "display. দিয়ে শুরু, যেমন display.whatsapp_support",
        group: "গ্রুপ",
        descriptionEn: "বিবরণ (ইংরেজি)",
        descriptionBn: "বিবরণ (বাংলা)",
        unitEn: "একক (ইংরেজি)",
        unitBn: "একক (বাংলা)",
        showOnPricing: "প্রাইসিং পেজে দেখান",
        archive: "আর্কাইভ",
        archived: "আর্কাইভ করা",
        restore: "ফিরিয়ে আনুন",
        edit: "এডিট",
        editLineTitle: "“{{feature}}” এডিট করুন",
        moveUp: "উপরে নিন",
        moveDown: "নিচে নিন",
        pricingHidden: "প্রাইসিংয়ে লুকানো",
        lineSaved: "ফিচার তালিকা সংরক্ষিত।",
        empty: "এখনো কোনো প্ল্যান নেই।",
        addons: {
            names: { locations: "বাড়তি লোকেশন", devices: "বাড়তি POS ডিভাইস", sms: "SMS প্যাক" },
            onSale: "বিক্রি চালু",
            off: "বিক্রি বন্ধ",
            perMonth: "প্রতি {{unit}}টির জন্য মাসে {{price}}",
            perPack: "{{unit}}টির প্যাক {{price}}",
            recurringHint: "ব্যবসার চলতি মেয়াদ শেষ হওয়া পর্যন্ত চলে; মেয়াদের মাঝে কিনলে বাকি দিনের হিসাবে দাম।",
            packHint: "এককালীন ক্রেডিট, মেয়াদ শেষ হয় না।",
            editTitle: "{{name}} এডিট করুন",
            unit: "প্যাকের আকার",
            unitHint: "এক প্যাকে কতটুকু যোগ হয় (যেমন ১টি লোকেশন, ১,০০০ SMS)।",
            monthlyPrice: "প্রতি প্যাকের মাসিক দাম (বার্ষিক প্ল্যানে ১২ গুণ)",
            packPrice: "প্রতি প্যাকের দাম",
            active: "ব্যবসাগুলোর কাছে বিক্রি চালু",
            saved: "অ্যাড-অন সংরক্ষিত।",
        },
        keptTitle: "রাখা প্ল্যান-শর্ত",
        keptDescription: "প্ল্যান ছোট করার সময় এই ব্যবসা যে মানগুলো রেখেছে। ওই প্ল্যানে থাকা পর্যন্ত প্রযোজ্য।",
        keptClear: "প্ল্যানের বর্তমান মানে নিন",
        keptClearTitle: "{{business}}-কে প্ল্যানের বর্তমান মানে নেবেন?",
        keptCleared: "ব্যবসাটি এখন প্ল্যানের বর্তমান মান পাচ্ছে।",
    },
    closures: {
        title: "বন্ধের অনুরোধ",
        description: "যে ব্যবসাগুলো বন্ধ করতে চেয়েছে (৩০ দিন শেষে নিজে থেকেই মুছে যায়) এবং মুছে ফেলা ব্যবসার মুছে ফেলার সনদ।",
        closing: "বন্ধ হচ্ছে",
        deleted: "মুছে ফেলা",
        noneClosing: "কোনো ব্যবসা বন্ধ হচ্ছে না।",
        noneDeleted: "কোনো ব্যবসা মুছে ফেলা হয়নি।",
        business: "ব্যবসা",
        requested: "অনুরোধ",
        due: "মুছে ফেলার তারিখ",
        reason: "তাদের কারণ",
        deletedAt: "মুছে ফেলার সময়",
        tables: "টেবিল",
        rows: "সারি",
        cancel: "বন্ধ করা বাতিল",
        cancelTitle: "এই ব্যবসা চালু রাখবেন?",
        cancelled: "বন্ধ করা বাতিল হয়েছে।",
    },
    themeDemos: {
        title: "থিমের ডেমো দোকান",
        description: "প্রতিটি স্টোরফ্রন্ট থিমের একটি করে ডেমো দোকান: অ্যাডমিনের “লাইভ ডেমো” এটি খোলে, তাই ব্যবসায়ী থিম বেছে নেওয়ার আগে দেখে নিতে পারেন। ডেমো দোকানে অর্ডার নেওয়া হয় না।",
        build_one: "{{count}}টি বাকি দোকান তৈরি করুন",
        build_other: "{{count}}টি বাকি দোকান তৈরি করুন",
        building: "তৈরি হচ্ছে…",
        queued: "পেছনে তৈরি হচ্ছে। প্রতিটি দোকানে এক-দুই মিনিট লাগে।",
        alreadyRunning: "একটি তৈরি আগে থেকেই চলছে।",
        empty: "কোনো থিম নেই।",
        theme: "থিম",
        address: "ঠিকানা",
        status: "অবস্থা",
        statuses: { ready: "চালু", missing: "তৈরি হয়নি", closed: "বন্ধ", taken: "ঠিকানাটি অন্য ব্যবসার" },
    },
    storefronts: {
        title: "অনলাইন স্টোর",
        description: "যেসব ব্যবসার অনলাইন স্টোর আছে। ফিশিং বা অপব্যবহারের জন্য বন্ধ করুন; আপনি না খোলা পর্যন্ত বন্ধ থাকবে।",
        empty: "এখনো কোনো অনলাইন স্টোর নেই।",
        business: "ব্যবসা",
        address: "ঠিকানা",
        status: "অবস্থা",
        orders: "অনলাইন অর্ডার (৩০ দিন)",
        live: "চালু",
        off: "বন্ধ",
        takenDown: "বন্ধ করা হয়েছে",
        takeDown: "বন্ধ করুন",
        restore: "আবার চালু করুন",
        takeDownTitle: "{{name}}-এর দোকান বন্ধ করবেন?",
        takeDownBody: "সব ঠিকানায় দোকানটি সঙ্গে সঙ্গে বন্ধ হবে। ব্যবসাটি কারণ দেখবে এবং নিজে আর খুলতে পারবে না।",
        restoreTitle: "{{name}}-এর দোকান আবার চালু করবেন?",
        restoreBody: "ব্যবসাটি দোকান চালু রাখলে আবার খুলবে।",
        takenDownDone: "দোকান বন্ধ করা হয়েছে।",
        restored: "দোকান আবার চালু হয়েছে।",
    },
    domains: {
        title: "দোকানের ডোমেইন",
        description: "অনলাইন স্টোরে যুক্ত নিজস্ব ডোমেইন। ফিশিং বা অপব্যবহারে ব্যবহৃত ডোমেইন ব্লক করুন।",
        all: "সব",
        search: "হোস্ট নাম খুঁজুন",
        empty: "কোনো ডোমেইন নেই।",
        host: "ডোমেইন",
        business: "ব্যবসা",
        status: "অবস্থা",
        since: "যোগ হয়েছে",
        block: "ব্লক করুন",
        blockTitle: "{{host}} ব্লক করবেন?",
        blockBody: "এই ডোমেইনে দোকানটি সঙ্গে সঙ্গে খোলা বন্ধ হবে এবং ব্যবসাটি এটি সরাতে বা আবার যুক্ত করতে পারবে না।",
        blocked: "ডোমেইন ব্লক হয়েছে।",
        statuses: {
            pending_dns: "DNS-এর অপেক্ষায়",
            verifying: "যাচাই হচ্ছে",
            active: "চালু",
            failed: "কাজ করছে না",
            blocked: "ব্লক করা",
        },
    },
    feedback: {
        title: "ফিডব্যাক",
        description: "বিটা দোকানগুলো অ্যাডমিন থেকে যা পাঠিয়েছে। সপ্তাহে একবার দেখুন: স্ট্যাটাস দিন, উত্তর দিন, নোট রাখুন।",
        all: "সব",
        empty: "কিছু নেই।",
        business: "ব্যবসা",
        sent: "পাঠানো",
        kind: "ধরন",
        message: "বার্তা",
        status: "স্ট্যাটাস",
        triage: "ট্রায়াজ",
        triageTitle: "ফিডব্যাক ট্রায়াজ",
        response: "ব্যবসায়ীকে উত্তর (ঐচ্ছিক)",
        note: "অভ্যন্তরীণ নোট",
        saved: "সংরক্ষিত।",
        kinds: { bug: "বাগ", idea: "আইডিয়া", question: "প্রশ্ন" },
        statuses: {
            new: "নতুন",
            triaged: "দেখা হয়েছে",
            planned: "পরিকল্পনায়",
            fixed: "ঠিক হয়েছে",
            wont_fix: "করা হবে না",
        },
    },
    leads: {
        title: "বিক্রয় অনুসন্ধান",
        description: "মার্কেটিং সাইটের এন্টারপ্রাইজ পেজ থেকে আসা অনুসন্ধান, নতুনগুলো আগে। এক দিনের মধ্যে ফোন করুন।",
        empty: "এখনো কোনো অনুসন্ধান নেই।",
        business: "ব্যবসা",
        contact: "যোগাযোগ",
        branches: "শাখা",
        message: "বার্তা",
        received: "পাওয়া গেছে",
    },
};
//# sourceMappingURL=super-admin.js.map